import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { debounce, map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { defaultImg } from "assets/images"
import moment from "moment"
import { deleteCategories, getCategories } from "store/actions"

const Categories = () => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    return parseInt(localStorage.getItem("testimonialLimit")) || 10
  })
  const [searchText, setSearchText] = useState("")

  const { Categories, loading, total } = useSelector(state => ({
    Categories: state?.Categories?.categories?.categories,
    total: state?.Categories?.categories?.total,
    loading: state.Categories.loading,
  }))

  const totalPages = Math.ceil(total / totalItemLimit)
  const pages = range(1, totalPages + 1)

  const sort = "member"

  useEffect(() => {
    dispatch(getCategories(page, totalItemLimit, searchText, "", sort))
  }, [dispatch, page, totalItemLimit, searchText, sort])

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })
  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }
  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteCategories(isOpen?.id))
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
    },

    {
      dataField: "createdAt",
      text: "Joined on",
      sort: true,
    },
    {
      dataField: "priority",
      text: "Priority",
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "webBanner",
      text: "Web Banner",
      sort: true,
    },
    {
      dataField: "appBanner",
      text: "App Banner",
      sort: true,
    },
    {
      dataField: "logoImages",
      text: "Logo Image",
      sort: true,
    },

    {
      dataField: "action",
      text: "Action",
    },
  ]

  const debounceUserSearch = debounce(value => setSearchText(value), 600)

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("testimonialLimit", e.target.value)
    }
  }

  const tableData = map(Categories, (item, index) =>
    // (item, "item"),
    ({
      ...item,
      no: <span>{index + 1 + (page - 1) * totalItemLimit}</span>,
      priority: <div style={{}}>{item?.priority || "---"}</div>,
      createdAt: moment(item.createdAt).format("DD/MM/YYYY - h:mm a"),
      webBanner: (
        <img
          className="d-block header-profile-user"
          style={{ width: "300px", height: "200px" }}
          src={
            item?.webBanners && item?.webBanners[0]
              ? item?.webBanners[0]?.url
              : defaultImg
          }
        />
      ),
      appBanner: (
        <img
          className="d-block header-profile-user"
          style={{ width: "150px", height: "100px" }}
          src={
            item?.appBanners && item?.appBanners[0]
              ? item?.appBanners[0]?.url
              : defaultImg
          }
        />
      ),
      logoImages: (
        <img
          className="d-block header-profile-user"
          style={{ width: "70px", height: "70px", borderRadius: "100%" }}
          src={
            item?.logoImages && item?.logoImages[0]
              ? item?.logoImages[0]?.url
              : defaultImg
          }
        />
      ),
      action: (
        <div>
          <Link to={`/categories/update/${item._id}`} className="btn-md">
            <i className="bx bx-edit me-2 " style={{ fontSize: "1.3rem" }} />
          </Link>
          <Button
            id={`Delete${index}`}
            type="button"
            color="white"
            className="ms-1 btn"
            onClick={() => {
              handleDelete(item?._id)
            }}
          >
            <i
              className="bx bx-trash me-2"
              style={{
                color: "red",
                marginBottom: "10px",
                fontSize: "1.3rem",
              }}
            />
          </Button>
        </div>
      ),
    })
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={isOpen?.status}
        onCloseClick={() => setIsOpen({ ...isOpen, stauts: false })}
        onDeleteClick={handleDeleteEvent}
      />
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={columns}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex justify-content-between flex-row-reverse">
                      <div>
                        <Link
                          to={{
                            pathname: "/categories/create",
                            state: "create",
                          }}
                        >
                          <Button
                            type="button"
                            color="warning"
                            className="btn-rounded  mb-2 me-2"
                            // onClick={handleClick}
                          >
                            <i className="mdi mdi-plus me-1" />
                            Add Category
                          </Button>
                        </Link>
                      </div>

                      <div className="d-flex">
                        <div>
                          {" "}
                          <div className="search-box mb-2 d-inline-block">
                            <div className="position-relative">
                              <AvForm>
                                <AvField
                                  name="searchText"
                                  placeholder="Search"
                                  type="text"
                                  onChange={e =>
                                    debounceUserSearch(e.target.value)
                                  }
                                />
                              </AvForm>
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>
                        <div>
                          <AvForm className="form-horizontal mx-2 mb-3 d-flex align-items-center">
                            <div className="mx-1">
                              <span className="">
                                Show
                                <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                              </span>
                            </div>
                            <div className="" style={{ width: "50px" }}>
                              <AvField
                                name="pageLimit"
                                className="form-control"
                                value={totalItemLimit}
                                onChange={e => handlePageLimit(e)}
                                type="text"
                                required
                              />
                            </div>
                          </AvForm>
                        </div>
                      </div>
                    </div>
                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    // onTableChange={handleTableChange}
                                    // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <MyPagination
                              totalPages={pages}
                              page={page}
                              setPage={setPage}
                            />
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">No Categories !</p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Categories
